module.exports = {
      id: "cancel-usage",
      viewBox: "0 0 241.171 241.171",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#cancel",
      toString: function () {
        return this.url;
      }
    }